export default __webpack_public_path__ + "static/media/FKGroteskNeue-Regular.bbb42d1b.woff2";